import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/machines/:name',
    name: 'MachineDetails',
    component: () => import('@/views/MachineDetails.vue'), // Single Machines view
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { guest: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Changed to use Vite style, if applicable
  routes
})

function isLoggedIn() {
  return !!localStorage.getItem('authToken') // Customize per actual auth logic
}

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()

  if (to.meta.requiresAuth && !loggedIn) {
    return next({ name: 'Login' })
  }

  if (to.meta.guest && loggedIn) {
    return next({ name: 'Dashboard' })
  }

  return next()
})

export default router
